/* eslint-disable */
import {
  FilterItemDto,
  ProductListDto,
  CreateProductListItemRequestDto,
  ProductListDtoQueryResultDto,
  ProductListItemDtoQueryResultDto,
  ProductListItemDto,
} from 'models/dtoTypes';
import { getProductListsApi } from 'services';
import { processResponse } from './openapiClient';
import { ProductListItemAttributes } from 'kosmos/models';

export const GetProductLists = async (options: {
  pageIndex: number;
  fullTextSearch?: string;
  filters?: FilterItemDto[];
  sortColumn?: string;
  isDesc?: boolean;
}): Promise<ProductListDtoQueryResultDto> => {
  const client = await getProductListsApi();
  const response = await client.getProductLists(options);
  return response.data;
};

export const GetProductListDetail = async (id: string): Promise<ProductListDto> => {
  const client = await getProductListsApi();
  const response = await client.getProductList(id);
  return response.data;
};

export const TriggerRescoringProductListItems = async (
  productListItemIds: string[],
  productListId: string,
): Promise<string> => {
  const client = await getProductListsApi();
  const response = await client.triggerRescoringByProductListItemIds({
    productListItemIds,
    productListId,
  });
  return response.data;
};

export const GetProductListItems = async (
  companyListId: string,
  options: {
    pageIndex: number;
    filters?: FilterItemDto[];
    sortColumn?: string;
    isDesc?: boolean;
  },
): Promise<ProductListItemDtoQueryResultDto> => {
  const client = await getProductListsApi();
  const response = await client.getProductListItems(companyListId, options);
  return response.data;
};


// export const GetProductListStatus = async (id: string): Promise<BulkStatusDto> => {
//   const client = await getProductListsApi();
//   const response = await client.getProductListStatus(id);
//   return response.data;
// };

export const CreateOrUpdateProductListItem = async (
  listId: string,
  attrs: ProductListItemAttributes,
): Promise<ProductListItemDto> => {
  const client = await getProductListsApi();
  const response = await client.createProductListItem(listId, attrs);
  return response.data;
};

export const UpdateProductList = async (
  id: string,
  attrs: {
    name?: string;
    description?: string;
  },
): Promise<ProductListDto> => {
  const client = await getProductListsApi();
  const res = await client.updateProductList(id, attrs);
  return res.data as ProductListDto;
};

export const CreateProductList = async (requestBody: {
  name: string;
  description: string;
}): Promise<ProductListDto> => {
  const client = await getProductListsApi();
  const response = await client.createProductList(requestBody);
  return response.data;
};

export const ReplaceProductListItems = async (
  listId: string,
  records: CreateProductListItemRequestDto[],
): Promise<ProductListDto> => {
  const client = await getProductListsApi();

  try {
    const response = await client.replaceProductListItems(listId, records);
    return processResponse<ProductListDto>(response);
  } catch (e) {
    console.log(e);
    return processResponse<ProductListDto>(e);
  }
};

export const DeleteProductList = async (id: string): Promise<void> => {
  const client = await getProductListsApi();
  await client.deleteProductList(id);
};
